export default __webpack_public_path__ + "static/media/HDTX_Materi Usulan Perubahan AD_RUPS 2021.27107c59.pdf";